import { Pipe, PipeTransform } from '@angular/core';
import { set, differenceInMilliseconds, addDays, max, min } from 'date-fns';
import Holidays from 'date-holidays';
import { TicketItem } from 'src/app/api/models';

@Pipe({
  name: 'calculateSla',
  pure: false,
})
export class CalculateSlaPipe implements PipeTransform {
  transform(ticket: TicketItem): number | string {
    if (ticket.ticket_type.id === 1) {
      return calcoloSla(ticket);
    } else {
      return '-';
    }
  }
}

//CALCOLO SLA TICKET

export const calcoloSla = (ticket: TicketItem): number => {
  const now = new Date();
  const created_on = new Date(ticket.opened_on as string);
  const holidays = new Holidays('IT');
  const workingMs = workingMsBetween(created_on, now, holidays);

  const workingHours = workingMs / (1000 * 60 * 60);

  const sub_tickets = ticket.sub_tickets?.length
    ? ticket.sub_tickets.filter(x => ![3, 37].includes(x.ticket_status.id))
    : [];

  let ticket_son_time_to_add = 0;

  if (sub_tickets.length) {
    for (let son of sub_tickets) {
      ticket_son_time_to_add +=
        workingMsBetween(new Date(son.opened_on), now, holidays) / (1000 * 60 * 60);
    }
  }

  return ticket.sla_hours - workingHours + timeToAddToSLA(ticket) + ticket_son_time_to_add;
};
function workingMsBetween(start: Date, end: Date, holidays: Holidays): number {
  let total = 0;
  let cursor = new Date(start);
  while (cursor <= end) {
    const day = cursor.getDay();
    if (day === 0 || day === 6) {
      cursor = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate() + 1, 8, 30);
      continue;
    }
    const normalized = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate());
    if (holidays.isHoliday(normalized)) {
      cursor = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate() + 1, 8, 30);
      continue;
    }
    const dayStart = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate(), 8, 30);
    const dayEnd = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate(), 18, 30);
    const effectiveStart = new Date(Math.max(dayStart.getTime(), start.getTime()));
    const effectiveEnd = new Date(Math.min(dayEnd.getTime(), end.getTime()));
    if (effectiveEnd > effectiveStart) {
      total += effectiveEnd.getTime() - effectiveStart.getTime();
    }
    cursor = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate() + 1, 8, 30);
  }
  return total;
}

function timeToAddToSLA(ticket: TicketItem): number {
  const history = ticket.ticket_histories;
  const open_close: { status: 'open' | 'close'; start: Date; end: Date }[] = [];
  for (let i = 0; i < history.length; i++) {
    const event = history[i];
    const isClose = event.related_status.suspend_sla;
    let end: Date = new Date();
    if (i < history.length - 1) {
      for (let j = i + 1; j < history.length; j++) {
        const next = history[j];
        if (!next.related_status.suspend_sla) {
          end = new Date(next.date);
          break;
        }
      }
    }
    open_close.push({ status: isClose ? 'close' : 'open', start: new Date(event.date), end });
  }
  let timeToAdd = 0;
  const holidays = new Holidays('IT');
  for (const x of open_close) {
    if (x.status === 'close') {
      timeToAdd += workingMsBetween(x.start, x.end, holidays);
    }
  }
  return timeToAdd / (1000 * 60 * 60);
}
